import MuiCssBaseline from "@mui/material/CssBaseline";

export const CssBaseline = () => <MuiCssBaseline />;
